var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_145_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7446 8.26132L11.5868 8.26093C11.2266 8.26093 10.9346 8.55288 10.9346 8.91311V11.5192C10.9346 11.8793 11.2266 12.1714 11.5868 12.1714H16.1807C15.6777 13.4769 14.7388 14.5702 13.5409 15.2649L15.4998 18.6558C18.642 16.8385 20.4998 13.6499 20.4998 10.0805C20.4998 9.57221 20.4623 9.20889 20.3874 8.79979C20.3304 8.48897 20.0606 8.26132 19.7446 8.26132Z",
    fill: "#167EE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 16.0869C8.25186 16.0869 6.2892 14.8586 5.2351 13.0409L1.84424 14.9953C3.56982 17.9861 6.8024 20 10.5001 20C12.314 20 14.0256 19.5116 15.5001 18.6605V18.6558L13.5412 15.2648C12.6452 15.7845 11.6083 16.0869 10.5001 16.0869Z",
    fill: "#12B347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 18.6605V18.6558L13.5411 15.2648C12.6451 15.7845 11.6083 16.087 10.5 16.087V20C12.3139 20 14.0256 19.5116 15.5 18.6605Z",
    fill: "#0F993E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.41305 9.99999C4.41305 8.89183 4.71547 7.85507 5.23504 6.95909L1.84418 5.00464C0.988359 6.47444 0.5 8.1814 0.5 9.99999C0.5 11.8186 0.988359 13.5255 1.84418 14.9953L5.23504 13.0409C4.71547 12.1449 4.41305 11.1082 4.41305 9.99999Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 3.91305C11.9661 3.91305 13.3128 4.43398 14.3646 5.30051C14.6241 5.51426 15.0012 5.49883 15.2389 5.26113L17.0854 3.41465C17.3551 3.14496 17.3359 2.70352 17.0478 2.45359C15.2855 0.924727 12.9925 0 10.5001 0C6.8024 0 3.56982 2.01395 1.84424 5.00465L5.2351 6.9591C6.2892 5.14141 8.25186 3.91305 10.5001 3.91305Z",
    fill: "#FF4B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3645 5.30051C14.624 5.51426 15.0012 5.49883 15.2389 5.26113L17.0854 3.41465C17.355 3.14496 17.3358 2.70352 17.0477 2.45359C15.2854 0.924688 12.9925 0 10.5 0V3.91305C11.966 3.91305 13.3127 4.43398 14.3645 5.30051Z",
    fill: "#D93F21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_145_135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.71a869a1703c7da5658fa490ec619fb3.svg";
export { ForwardRef as ReactComponent };